import { useState } from "react";
import { UseFormReset } from "react-hook-form";
import { HTTP_STATUSES } from "@miplatform/constants";
import { BidLineItemType, IBidLineItemResponse } from "@miplatform/types";
import { useBidLineItems, useCategories } from "@mibuildweb/hooks";
import { IBidLineItemPayload } from "../../CustomerPricingDetails/CustomerPricingDetails.types";

export const useCustomerLineItemsTabsViewModel = ({
  accountId,
  bidLineItemType,
  reset,
}: {
  accountId: string;
  bidLineItemType: BidLineItemType;
  reset: UseFormReset<IBidLineItemPayload>;
}) => {
  const [openLineItemForm, setOpenLineItemForm] = useState<boolean>(false);
  const [openDeleteModal, setOpenDeleteModal] = useState<boolean>(false);
  const [selectedLineItem, setSelectedLineItem] =
    useState<IBidLineItemResponse | null>(null);

  const {
    categories,
    getCategories,
    isLoading: isCategoriesLoading,
  } = useCategories();

  const {
    bidLineItems,
    getBidLineItems,
    createBidLineItem,
    updateBidLineItem,
    deleteBidLineItem,
    isLoading: isBidLineItemsLoading,
  } = useBidLineItems();

  const handleCreateBidLineItem = async (data: IBidLineItemPayload) => {
    const response = await createBidLineItem(data);
    if (response.status === HTTP_STATUSES.OK && accountId) {
      getBidLineItems(accountId, bidLineItemType);
      setOpenLineItemForm(false);
    }
    return response;
  };

  const handleUpdateBidLineItem = async (
    id: string,
    data: IBidLineItemPayload
  ) => {
    const response = await updateBidLineItem(id, data);
    if (response.status === HTTP_STATUSES.OK && accountId) {
      getBidLineItems(accountId, bidLineItemType);
      setOpenLineItemForm(false);
    }
    return response;
  };

  const handleDeleteBidLineItem = async (
    data: Partial<IBidLineItemResponse>
  ) => {
    const response = await deleteBidLineItem(data);
    if (response.status === HTTP_STATUSES.OK && accountId) {
      getBidLineItems(accountId, bidLineItemType);
    }
    return response;
  };

  const handleConfirmDeleteModal = async () => {
    if (selectedLineItem) {
      await handleDeleteBidLineItem(selectedLineItem);
      setSelectedLineItem(null);
      setOpenDeleteModal(false);
    }
  };

  return {
    openLineItemForm,
    setOpenLineItemForm,
    categories,
    getCategories,
    bidLineItems,
    getBidLineItems,
    openDeleteModal,
    setOpenDeleteModal,
    selectedLineItem,
    setSelectedLineItem,
    handleCreateBidLineItem,
    handleUpdateBidLineItem,
    handleDeleteBidLineItem,
    handleConfirmDeleteModal,
    isLoading: isCategoriesLoading || isBidLineItemsLoading,
  };
};
